export const saveToHome = () => {
  if (window.deferredPrompt) {
    window.deferredPrompt.prompt();
    window.deferredPrompt.userChoice.then(() => {
      window.deferredPrompt = null;
      recordAppInstalled();
    });
  }
};

const LAST_PROMPT_KEY = "pwa_last_prompt_time";
const APP_DISMISSED_KEY = "pwa_dismissed_time";
const APP_INSTALLED_KEY = "pwa_installed";

export const shouldShowInstallPrompt = () => {
  if (!window.deferredPrompt) {
    return false;
  }

  if (isAppInstalled()) {
    return false;
  }

  if (wasPromptShownRecently()) {
    return false;
  }

  return true;
};

export const isAppInstalled = () => {
  if (window.navigator.standalone === true) {
    return true;
  }

  if (window.matchMedia("(display-mode: standalone)").matches) {
    return true;
  }

  return localStorage.getItem(APP_INSTALLED_KEY) === "true";
};

export const wasPromptShownRecently = () => {
  const lastPromptTime = localStorage.getItem(LAST_PROMPT_KEY);
  if (!lastPromptTime) {
    return false;
  }

  const now = new Date().getTime();
  const lastPrompt = parseInt(lastPromptTime, 10);
  const twentyFourHours = 24 * 60 * 60 * 1000;

  return now - lastPrompt < twentyFourHours;
};

export const recordPromptShown = () => {
  const now = new Date().getTime();
  localStorage.setItem(LAST_PROMPT_KEY, now.toString());
};

export const recordAppInstalled = () => {
  localStorage.setItem(APP_INSTALLED_KEY, "true");
  localStorage.removeItem(LAST_PROMPT_KEY);
};

export const recordAppUninstalled = () => {
  localStorage.removeItem(APP_INSTALLED_KEY);
  const now = new Date().getTime();
  localStorage.setItem(APP_DISMISSED_KEY, now.toString());
};

export const initPWATracking = () => {
  const handleBeforeInstallPrompt = (e) => {
    e.preventDefault();
    window.deferredPrompt = e;
  };

  window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

  window.addEventListener("appinstalled", () => {
    recordAppInstalled();
  });

  const wasInstalled = localStorage.getItem(APP_INSTALLED_KEY) === "true";
  if (wasInstalled && !isAppInstalled()) {
    recordAppUninstalled();
  }
};
